import ElectronIPC from '../../services/ElectronIPC'
import { Button } from '@/UIComponents2/Button'
import GearIcon from '@/CustomIcons/GearIcon'
import RefreshIcon from '@/CustomIcons/RefreshIcon'
import InfoTriangleIcon from '@/CustomIcons/InfoTriangleIcon'

export default function PermissionRequiredFragment() {
    return (
        <div className="flex flex-col h-full items-center justify-center">
            <div className="w-[80%] md:w-[500px]">
                <div className="flex items-center gap-2 text-xl font-semibold pb-6">
                    <InfoTriangleIcon />
                    <span>Screen capture permission required</span>
                </div>
                <div className="text-sm pb-2">
                    To share your screen, please grant screen capture permissions for this app in your Mac settings.
                </div>
                <Button
                    variant="link"
                    onClick={() => {
                        ElectronIPC.openMacSystemPreferences({ pane: 'security', section: 'Privacy_ScreenCapture' })
                    }}
                >
                    <div className="flex items-center gap-1">
                        <span>Open Mac screen capture settings</span>
                        <GearIcon className="py-[2px]" />
                    </div>
                </Button>

                <div className="text-sm pt-10 pb-2">
                    You may need to restart the app in order for the changes to take effect.
                </div>
                <Button
                    variant="link"
                    onClick={() => {
                        ElectronIPC.quitApp({ immediate: true, relaunch: true })
                    }}
                >
                    <div className="flex items-center gap-1">
                        <span>Restart app</span>
                        <RefreshIcon className="py-[2px]" />
                    </div>
                </Button>
            </div>
        </div>
    )
}
